import { Component } from 'react';
import ActivityReportList from "../components/ActivityReportList";
import { reportFetchData } from '../redux/activityReport/activityReportActions';
import { loadActiveUser } from "../redux/users/usersActions";
import withAuth from '../components/withAuth';
import { compose } from "redux";
import { connect } from "react-redux";
import _ from 'lodash';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

class ActivityReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeUser: props.activeUser,
            report: props.report,
        };
    }

    componentDidMount() {
        this.props.loadActiveUser();
        this.props.reportFetchData(this.props.activeUser.emp_id);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;

        if (nextProps.activeUser !== undefined && nextProps.activeUser !== null && nextProps.activeUser !== prevState.activeUser) {
            modifiedState.activeUser = nextProps.activeUser
        }

        if (nextProps.report !== undefined && nextProps.report !== prevState.report) {
            modifiedState.report = nextProps.report
        }

        return modifiedState;
    }

    render() {
        let weekGroups = _.groupBy(this.state.report.counters, 'week_name')
        let reportItems = Object.keys(weekGroups).map((key, index) => { return <ActivityReportList key={index} days={weekGroups[key]} week={key} /> });

        return (
            <div style={{ width: "100%", minHeight: "100vh", height: "100vh", maxHeight: "100vh", overflowY: "auto", position: "relative" }}>
                {this.state.report !== null && reportItems.length > 0 ?
                    <div style={{ width: "100%" }}>
                        {reportItems}
                    </div>
                    :
                    <div className="offset-lg-4 col-lg-4 offset-md-2 col-md-8 col-sm-12 col-12 body-margin-top">
                        <Card>
                            <CardHeader title={"Aucune donnée disponible actuellement"} />
                        </Card>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        report: state.report
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        loadActiveUser: () => dispatch(loadActiveUser()),
        reportFetchData: (empId) => dispatch(reportFetchData(empId))
    };
};
export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(ActivityReport);
